import {
    ErrorPayload, ILogger, LoggerContext, LoggerLevel, LogMessage, MessagePayload,
} from 'src/types';
import { LOGGER_LEVEL } from 'src/constants';

function shouldLog(level: number, logLevel: number): boolean {
    return level >= logLevel;
}

const logLevelToLevelName: { [index: number]: LoggerLevel } = {
    [LOGGER_LEVEL.CRITICAL]: 'critical',
    [LOGGER_LEVEL.DEBUG]: 'debug',
    [LOGGER_LEVEL.ERROR]: 'error',
    [LOGGER_LEVEL.INFO]: 'info',
    [LOGGER_LEVEL.WARNING]: 'warning',
};

export const logMessage: LogMessage = async (
    level: LOGGER_LEVEL,
    message: MessagePayload | Error,
    // eslint-disable-next-line default-param-last
    context: LoggerContext = {} as LoggerContext,
    error: ErrorPayload | undefined,
    logger: ILogger,
): Promise<null> => {
    const logLevel = logLevelToLevelName[level];
    const { config } = logger;

    if (!shouldLog(level, config.logLevel)) {
        return null;
    }

    // TODO convert this to use the `before:log` event instead to consolidate API
    const { message: payload, context: ctx } = config.transforms.reduce(
        (accum, transform) => transform(accum.message, accum.context, logLevel, config),
        { context, message: ((typeof message !== 'object') ? { message } : message) },
    );

    for (const transport of config.transports) {
        if (transport) {
            transport.log(logLevel, payload, ctx, error, logger);
        }
    }

    return null;
};
